import { ConnectedArtist, FilterAlbumType, FilterInstrumental, FollowItemType, RestCampaignData, SetlistTrackType } from '@/types'
import { sleep } from '@/utils/sleep'

class AccountRestMock {
  public async get (token: string | null, campaignId: number): Promise<ConnectedArtist[]> {
    await sleep(1200)

    return new Promise((resolve) => resolve([
      {
        streaming_service: 'spotify',
        streaming_service_id: '123',
        display_name: 'Wessel',
        token: 'token-1',
        campaign_id: 1,
        id: 12,
        connected_at: '2022-01-06T16:25:45.796Z'
      }
    ]))
  }

  public async delete (token: string | null, campaignId: number, userId: number): Promise<void> {
    await sleep(1200)

    return new Promise((resolve) => resolve())
  }
}

export default new AccountRestMock()
